module.exports = __webpack_public_path__ + "img/pg4-article1-bg.2d07ec72.png";